import { asset1, asset2, asset3, asset4 } from './assets'

const assets = [
  { src: asset1, x: 0, y: 0, itemId: 'dieCast', position: 'Right' },
  // { src: asset2, x: 25.1062, y: 30.4255, overlay: true },
  { src: asset3, x: 806.1959, y: -0.0002, itemId: 'dieCast', position: 'Left' },
  // { src: asset4, x: 822.8633, y: 30.4253, overlay: true },
]

const data = {
  assets: assets,
}

export default data
